// src/components/richtext/ColorSwatch.jsx
import React, { useEffect, useRef, useState } from 'react'

const TEXT_PRESETS = [
  '#1a1a1a', '#dc2626', '#ea580c', '#ca8a04',
  '#16a34a', '#0891b2', '#2563eb', '#7c3aed',
  '#b08d57', '#666666', '#999999', '#ffffff',
]

const HIGHLIGHT_PRESETS = [
  '#fef3c7', '#fde68a', '#fed7aa', '#fecaca',
  '#bbf7d0', '#bae6fd', '#ddd6fe', '#fbcfe8',
  '#e0e7ff', '#fef9c3', '#d1fae5', '#fda4af',
]

export default function ColorSwatch({
  kind, // 'text' | 'highlight'
  current,
  onChange,
  onUnset,
  label,
}) {
  const [open, setOpen] = useState(false)
  const wrapperRef = useRef(null)
  const nativeRef = useRef(null)

  useEffect(() => {
    if (!open) return
    const onDocClick = (e) => {
      if (!wrapperRef.current?.contains(e.target)) setOpen(false)
    }
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false) }
    document.addEventListener('mousedown', onDocClick)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('mousedown', onDocClick)
      document.removeEventListener('keydown', onKey)
    }
  }, [open])

  const presets = kind === 'highlight' ? HIGHLIGHT_PRESETS : TEXT_PRESETS

  return (
    <div className="rte-swatch" ref={wrapperRef}>
      <button
        type="button"
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => setOpen(o => !o)}
        aria-label={label}
        aria-haspopup="dialog"
        aria-expanded={open}
        className={`rte-label ${kind === 'highlight' ? 'bg' : ''}`}
        style={current ? { borderColor: current, boxShadow: `inset 0 -3px 0 ${current}` } : undefined}
      >
        A
      </button>
      {open && (
        <div className="rte-swatch-popover" role="dialog" aria-label={label}>
          <div className="rte-swatch-grid">
            {presets.map(c => (
              <button
                key={c}
                type="button"
                aria-label={`${label}: ${c}`}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => { onChange(c); setOpen(false) }}
                className={`rte-swatch-dot ${current?.toLowerCase() === c.toLowerCase() ? 'is-active' : ''}`}
                style={{ background: c }}
              />
            ))}
          </div>
          <div className="rte-swatch-actions">
            <button
              type="button"
              className="rte-swatch-action"
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => nativeRef.current?.click()}
            >
              More…
            </button>
            {current && (
              <button
                type="button"
                className="rte-swatch-action rte-swatch-remove"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => { onUnset(); setOpen(false) }}
              >
                Remove
              </button>
            )}
          </div>
          <input
            ref={nativeRef}
            type="color"
            value={current || '#000000'}
            onChange={(e) => { onChange(e.target.value); setOpen(false) }}
            style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}
            tabIndex={-1}
            aria-hidden="true"
          />
        </div>
      )}
    </div>
  )
}
